const opponentData = [
  {
    value: 0,
    label: "Bhadwa",
  },
  {
    value: 1,
    label: "Miranda",
  },
  {
    value: 2,
    label: "Small PP",
  },
  {
    value: 3,
    label: "Shiku Banda",
  },
  {
    value: 4,
    label: "Noice",
  },
  {
    value: 5,
    label: "Laanti",
  },
];

const filterTable = [
  {
    value:0,
    label:"By Name",
  },
  {
    value:1,
    label:"By Rating"
  },
  {
    value:2,
    label:"By Matches Won"
  },
  {
    value:3,
    label:"By Matches Lost"
  }
];

const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
]

export {opponentData,filterTable,months};